import React from "react";
import AnnouncementItem from "../Common/AnnouncementItem";
import AnnoucementImage01 from "../../../../assets/image/image-annoucement-01.webp";
import useFetch from "../../../../hooks/useFetch";
import { getBlogList } from "../../../../services/BlogService";
import dayjs from "dayjs";
import Button from "../../../form/Button";

const SectionAnnoucements = () => {
  // const announcementData = [
  //   {
  //     _id: 1,
  //     title: "Cultural Exchange: Building Global",
  //     description: "Stay connected with the latest announcements from the V’Peters Family Scholarship. Explore our calendar for upcoming events and see how we’re making a lasting impact!",
  //     image: AnnoucementImage01,
  //     date: {
  //       day: 22,
  //       month: "January",
  //     },
  //     link: "/updates/1"
  //   },
  //   {
  //     _id: 2,
  //     title: "Cultural Exchange: Building Global",
  //     description: "Stay connected with the latest announcements from the V’Peters Family Scholarship. Explore our calendar for upcoming events and see how we’re making a lasting impact!",
  //     image: AnnoucementImage01,
  //     date: {
  //       day: 22,
  //       month: "January",
  //     },
  //     link: "/updates/2"
  //   },
  // ];

  const {
    data: announcementData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-event-announce"],
    fetchFunction: async () => {
      const res = await getBlogList({
        type: "event",
        limit: 2,
        sortQuery: "-createdAt",
        upcomingEvent: true,
        status: 1,
      });
      if (res?.docs?.status === 200) {
        return {
          ...res?.docs,
          data: (res?.docs?.data || [])?.map((item) => ({
            ...item,
            _id: item?._id,
            date: {
              day: dayjs(item?.publishDate)?.format("DD"),
              month: dayjs(item?.publishDate)?.format("MMMM"),
            },
            image: item?.image?.url,
            link: `/updates/${item?.slug || item?._id}`,
          })),
        };
      } else {
        return { ...res, data: [] };
      }
    },
  });

  return (
    <section className="relative flex w-full py-10 1xl:py-24 bg-white">
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
        {Array.isArray(announcementData?.data) &&
          announcementData?.data?.length > 0 && (
            <div className="">
              {announcementData?.data?.map((item, index) => (
                <AnnouncementItem key={index} index={index} data={item} />
              ))}
            </div>
          )}
        <div className="flex items-center justify-center mt-16">
          <Button
            buttonLabel={"View All Events"}
            buttonClasses={
              "!h-12 xl:!h-14 !rounded-full !px-6 xl:!px-10 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-60"
            }
            buttonLabelClasses={"!text-base xl:!text-xl"}
            buttonHasLink={true}
            buttonLink={"/events"}
          />
        </div>
      </div>
    </section>
  );
};

export default SectionAnnoucements;
